import { Component, inject, Input, OnInit } from '@angular/core';
import { Environment, EnvironmentService } from '@galaxy/core';
import { SnackbarService } from '@vendasta/galaxy/snackbar-service';

@Component({
  selector: 'meeting-scheduler-settings-add-to-website-card',
  templateUrl: './add-to-website.component.html',
  styleUrls: ['./add-to-website.component.scss'],
  standalone: false,
})
export class AddToWebsiteComponent implements OnInit {
  @Input() isUpdate: boolean;
  @Input() calendarId: string;
  @Input() type = 'book'; // book / group / service
  @Input() name: string; // eventtypename / groupname / servicename
  @Input() id: string; // eventtypeid / groupId / serviceId
  @Input() slug: string; // eventtypeslug / groupSlug / serviceSlug

  selectedWidgetType = 'inline';
  slideOutImage = 'https://storage.googleapis.com/meeting-scheduler-prod-public-images/slideout_embed.png'; //TODO store in gcp
  inlineImage = 'https://storage.googleapis.com/meeting-scheduler-prod-public-images/inline_embed.png'; //TODO
  widgetEmbedCode = '';
  private readonly environmentService = inject(EnvironmentService);

  constructor(private readonly alertService: SnackbarService) {}

  ngOnInit(): void {
    this.loadEmbedCode();
  }

  onRadioChange(event: any): void {
    this.selectedWidgetType = event.value;
    this.loadEmbedCode();
  }

  loadEmbedCode() {
    const env = this.environmentService.getEnvironment();
    const isProd = env === Environment.PROD;
    const hostUrl = isProd ? 'https://bookmenow.info' : 'https://meetings-demo.apigateway.co';
    const widgetUrl = `${hostUrl}/assets/js/widget.js`;
    let bookingLink = `${hostUrl}/${this.type}`;

    if (this.type === 'book') bookingLink += `/${this.calendarId}/${this.id}`;
    else bookingLink += `/${this.id}/${this.slug}`;

    const widgetClass =
      this.selectedWidgetType === 'inline'
        ? `bookmenow-${this.selectedWidgetType}-widget`
        : `bookmenow-${this.selectedWidgetType}-widget-url`;

    const inlineStyle = this.selectedWidgetType === 'inline' ? ' style="min-width:320px; height:710px;"' : '';

    this.widgetEmbedCode = `<!-- bookmenow ${this.selectedWidgetType} widget embed script begin -->
<div class="${widgetClass}" data-url="${bookingLink}"${inlineStyle}></div>
<script type="text/javascript" src="${widgetUrl}"></script>
<!-- bookmenow ${this.selectedWidgetType} widget embed script end -->`.trim();
  }

  handleCopyEmbedCodeClicked(): void {
    this.alertService.openSuccessSnack('MEETING_SCHEDULER.BOOKING_LINK.EMBED_CODE_SECTION.COPY_TO_CLIP_BOARD');
  }
}
